export enum GuestType {
  UnknownType2 = 6,
  Infant = 7,
  Child = 8,
  UnknownType1 = 9,
  Adult = 10,
  Senior = 11,
}
